import { Box, Button, Stack, Typography } from '@mui/material'
import React from 'react'
import HeroBannerImage from "../asstes/images/banner.png";
function HeroBanner() {
  return (
    <Box sx={{ mt: { lg: "212px", xs: "70px" }, ml: { sm: "50px" } }} p="20px" position="relative">
      <Typography color="#FF2625" fontWeight="600" fontSize="26px">
        Fitness club
      </Typography>
      <Typography
        fontWeight="700"
        sx={{ fontSize: { lg: "44px", xs: "40px" } }}
        mb="23px"
        mt="30px"
      >
        Sweat, Smile <br />
        and Repeat
      </Typography>
      <Typography sx={{ fontSize: { lg: "44px", xs: "40px" } }}>
        Check out the most effective exercises personalized to you
      </Typography>
    
      <Stack>
        <Button
          href="#exercises"
          variant="contained"
          color="error"
          style={{
            width: "200px",
            padding: "14px",
            borderRadius: "4px",
            marginTop: "45px",
          }}
        >
          Explore Exercises
        </Button>
      </Stack>
      <Typography
        fontWeight={600}
        color="#FF2625"
        sx={{
          opacity: "0.1",
          display: { lg: "block", xs: "none" },
          fontSize: "200px",
        }}
      >
        Exercises
      </Typography>
      <img
        src={HeroBannerImage}
        alt="hero-banner"
        className="hero-banner-img"
      />
    </Box>
  );
}

export default HeroBanner
